@let
c = conf();
<div class="menu-crud-tile" [ngClass]="{'menu-crud-tile-active':c.active ? c.active() : false}" OnHold (onHold)="!toggle() ? c.func() : undefined" (click)="toggle() ? c.func() : undefined">
	<div class="menu-crud-tile-icon">{{c.icon}}</div>
	<div class="menu-crud-tile-text">
		@for (
				text of c.text; track text) {
			<div class="tile-text">{{text}}</div>
		}
	</div>
</div>